import { useFailedUniOrders } from "modules/unicommerce/store";
import React from "react";
import { Button } from "react-bootstrap";

const ExcelGenerator = ({ selectedOrderDisplayIDs }) => {
  const { postFailedData } = useFailedUniOrders();
  const sendCSVToApi = async () => {
    const csvContent =
      "Order Display Id\n" + selectedOrderDisplayIDs.join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });

    const formData = new FormData();
    formData.append("file", blob, "selected_orders.csv");

    try {
      const response = postFailedData(formData);

      if (response.ok) {
        console.log("CSV file sent successfully");
      } else {
        console.error("Failed to send CSV file:", response.statusText);
      }
    } catch (error) {
      console.error("Error sending CSV file:", error);
    }
  };

  return (
    <Button
      type="button"
      variant="falcon-default"
      size="sm"
      className="ms-2"
      disabled={selectedOrderDisplayIDs.length === 0}
      onClick={sendCSVToApi}
    >
      Send to UniCommerce
    </Button>
  );
};

export default ExcelGenerator;
